const moment = require('moment');
import {t} from 'l10n'

export function formatDate(date) {
    return moment(date).format(t('MM/DD/YYYY [at] HH:mm'));
}

export function formatDateDash(date) {
    return moment(date).format(t('MM/DD/YYYY – HH:mm'));
}

export function formatDateDMY(date) {
    return moment(date).format(t('MM/DD/YYYY'));
}

export function formatDateHM(date) {
    return moment(date).format(t('HH:mm'));
}

export function formatUnixDateDMY(date) {
    return moment.unix(date).format(t('MM/DD/YYYY'));
}


// WEBPACK FOOTER //
// ./src/utils/formatDate.js